import { Store } from "vuex";
import { ProductVersion } from "@/apps/merchant3/types/ProductVersion";
import { store } from "@/shared-store";
import { IVuexState } from "@/apps/merchant3/shared-models/IVuex";
import { isColombiaSaleFlow } from "@/apps/merchant3/helpers/checkoutFlows";

export const isSelfServiceSale = (): boolean => {
  const selfOnboardingCart = isSelfServiceCart();
  const isKiosk = sessionStorage.getItem("isKiosk") ?? "false";

  return selfOnboardingCart && isKiosk === "false";
};

export const isSelfServiceCart = (): boolean => {
  const vuexStore = store as unknown as Store<IVuexState>;

  return (
    vuexStore.state.carts?.productVersion == ProductVersion.M3_SELF_ONBOARDING
  );
};

export const isColombiaSelfServiceFlow = (): boolean => {
  return isColombiaSaleFlow() && isSelfServiceCart();
};
